import { getDomainLanguage } from '../utils/browser';

export const DE = 'de';
export const NL = 'nl';

const LOCALES = {
  DE,
  NL,
};

export const BROWSER_LANGUAGE = navigator.language || navigator.userLanguage;
export const DOMAIN_LANGUAGE =
  getDomainLanguage() ||
  (process.env.NODE_ENV === 'staging' &&
    process.env.REACT_APP_LOCALE &&
    LOCALES[process.env.REACT_APP_LOCALE]) ||
  DE;

export const isDomainDE = () => DOMAIN_LANGUAGE === DE

export const isDomainNL = () => DOMAIN_LANGUAGE === NL
